import { render, staticRenderFns } from "./BuyOrderPage.vue?vue&type=template&id=219a739e"
import script from "./BuyOrderPage.vue?vue&type=script&lang=js"
export * from "./BuyOrderPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports